import { createReducer } from '@reduxjs/toolkit';
import { pageLoaded } from './adobe-launch.actions';

/* -------------------------------------------------------------------------------------------------
 * config
 * -----------------------------------------------------------------------------------------------*/
const initialState = {
  previousLocation: '' as string,
};

/* -------------------------------------------------------------------------------------------------
 * reducer
 * -----------------------------------------------------------------------------------------------*/
const adobeLaunchReducer = createReducer(initialState, (builder) => {
  builder.addCase(pageLoaded, (state, { payload }) => {
    state.previousLocation = payload;
  });
});

export default adobeLaunchReducer;
